import { Roles } from './enums';

export default {
  Any: [Roles.Administrator, Roles.Editor, Roles.Observer, Roles.Fuel_Shortage],
  Editor: [Roles.Administrator, Roles.Editor],
  Observer: [Roles.Administrator, Roles.Editor, Roles.Observer],
  Administrator: [Roles.Administrator],
};
